<template>
    <div class="frame" :style="{ backgroundColor: bgColor || '#f9f9f9' }">
      <font-awesome-icon v-if="iconName" :icon="['fas', iconName]" class="custom-icon" />
      <div class="number">{{ valueWithUnit }}</div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      valueWithUnit: {
        type: String,
        required: false,
      },
      bgColor: {
        type: String,
        required: false,
      },
      iconName: {
        type: String,
        required: false,
      },
    },
  };
  </script>
  
  <style scoped>
  .frame {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2%;
    border: 1px solid #ccc;
    border-radius: 10px;
    margin-bottom: 10px;
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
  }
  
  .number {
    color: black;
    font-size: 1.4em;
    font-weight: bold;
    margin: 0.2rem;
  }
  
  .custom-icon {
    font-size: 2rem;
  }
  
  @media (max-width: 750px) {
    .frame {
     padding: 2%;
    }
  
    .number {
      font-size: 0.5rem;
    }

    .custom-icon {
        font-size: 0.6rem;
        margin-left: 0.2rem;
  }
  }
  </style>
  